module.exports = __webpack_public_path__ + "static/media/bike-image-02-02.4e32d826.png";